package com.tovtalk.di

import com.lomdaat.ads.platform.AdsIdentityProvider
import com.tovtalk.data.analytics.AnalyticsClient
import com.tovtalk.data.analytics.NoOpAnalyticsClient
import com.tovtalk.data.local.DatabaseDriverFactory
import com.tovtalk.data.remote.firebase.JsFirebaseAuthManager
import com.tovtalk.data.repository.JsChatRepositoryFirestore
import com.tovtalk.data.repository.WebAdsIdentityProvider
import com.tovtalk.domain.repository.AuthManager
import com.tovtalk.domain.repository.ChatRepository
import org.koin.core.module.Module
import org.koin.dsl.module

actual val platformModule: Module = module {
    single { DatabaseDriverFactory() }
    single<com.russhwolf.settings.Settings> {
        com.russhwolf.settings.StorageSettings()
    }
    single<AuthManager> { JsFirebaseAuthManager() }
    single<ChatRepository> {
        JsChatRepositoryFirestore(get<AuthManager>() as JsFirebaseAuthManager, get(), get())
    }
    single<AdsIdentityProvider> { WebAdsIdentityProvider() }
    single {
        val loader = coil3.ImageLoader.Builder(coil3.PlatformContext.INSTANCE)
            .components {
                add(com.tovtalk.data.cache.S3CacheKeyInterceptor())
            }
            .build()
        coil3.SingletonImageLoader.setSafe { loader }
        loader
    }

    // Web uses NoOpAnalyticsClient — no SQLDelight driver, no server-side session tracking.
    single<AnalyticsClient> { NoOpAnalyticsClient }
}
